/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Validation_Discount_RangeInputs */

const vi_order_validation_discount_range = /** @type {(inputs: Order_Validation_Discount_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiết khấu phải từ 0 đến 100%`)
};

/**

* @param {Order_Validation_Discount_RangeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_validation_discount_range = /** @type {((inputs?: Order_Validation_Discount_RangeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Validation_Discount_RangeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_validation_discount_range(inputs)
});